import { clsx } from '../../../lib/clsx.ts';

import styles from './Heading1.module.css';

import type { HeadingProps } from './text.types';

export function Heading1(props: HeadingProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <h1
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </h1>
  );
}
